module.exports = __webpack_public_path__ + "static/media/perfil.b2bbd515.jpeg";